import(/* webpackMode: "eager" */ "/tmp/build_81f94c18/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_81f94c18/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"]}],\"variableName\":\"nunito\"}");
;
import(/* webpackMode: "eager" */ "/tmp/build_81f94c18/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_81f94c18/src/components/Atoms/Footer/ConditionalFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_81f94c18/src/components/Molecules/UserRatingBar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoThemeProvider"] */ "/tmp/build_81f94c18/src/context/DemoThemeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderProvider"] */ "/tmp/build_81f94c18/src/context/HeaderContext.tsx");
